export default function _of(x) {
  return [x];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_of.js
// module id = 308
// module chunks = 23